module.exports = __webpack_public_path__ + "static/assets/64b8cdfb93517e8e72d928ef164fb399.svg";